import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { END } from 'redux-saga';
import Head from 'next/head';
import nextI18nextConfig from '~/../next-i18next.config';
import { wrapper } from '~/store';
import Layout from '~/containers/Layout';
import TermsAIPage from '~/containers/TermsAIPage';
import HrefLangs from '~/components/HrefLangs';
import MetaTwitter from '~/components/MetaTwitter';
import defaultPage, {
  defaultPageServerSideContext,
} from '~/../hocs/defaultPage';
import config, { keyConfig } from '~/config';

const TermsAI = (props) => {
  const { t, lng } = props;

  return (
    <Layout {...props}>
      <Head>
        <title>{t('photo_title_ai_terms_of_service_page')}</title>
        <meta
          id="meta-keywords"
          name="keywords"
          content={t('photo_meta_keywords_terms_of_service_page')}
        />
        <meta
          id="meta-description"
          name="description"
          content={t('photo_meta_description_ai_terms_of_service_page', {
            total: 1000000,
          })}
        />
        <HrefLangs pagePath="/terms-ai" lng={lng} />
        <meta
          property="og:image"
          content={`${
            config.staticPrefix
          }/static/assets/image/logo/${config.renderImageShareTwitter()}`}
        />
        <meta
          property="og:title"
          content={t(keyConfig.get('title_terms_of_service_page'), {
            total: 1000000,
          })}
        />
        <meta
          property="og:description"
          content={t(keyConfig.get('meta_description_terms_of_service_page'), {
            total: 1000000,
          })}
        />
        <meta property="og:url" content={`${config.getSiteURL()}/about-us`} />

        <meta property="og:type" content="article" />
        <meta
          property="og:description"
          content={t(keyConfig.get('meta_description_terms_of_service_page'), {
            total: 1000000,
          })}
        />
        <MetaTwitter
          url={`${config.getSiteURL()}/about-us`}
          title={t(keyConfig.get('title_terms_of_service_page'))}
          description={t(
            keyConfig.get('meta_description_terms_of_service_page'),
            {
              total: 1000000,
            },
          )}
          image={`${
            config.staticPrefix
          }/static/assets/image/logo/${config.renderImageShareTwitter()}`}
          site={`${config.getSiteURL()}/about-us`}
          twitterUser={config.getName()}
        />
      </Head>
      <TermsAIPage />
    </Layout>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(
  (store) => async (ctx) => {
    const i18nProps = await serverSideTranslations(
      ctx.locale || process.env.LANGUAGE,
      ['common', 'page-terms-ai'],
      nextI18nextConfig,
    );

    const {
      token,
      profile,
      accountType,
      isAuthenticated,
      currentLanguage,
      clientIp,
      api,
      sessionId,
      ssoToken,
      query,
    } = await defaultPageServerSideContext({
      ...ctx,
      store,
    });

    // end the saga
    store.dispatch(END);
    await store.sagaTask.toPromise();

    return {
      props: {
        ...i18nProps,
        token,
        profile,
        accountType,
        isAuthenticated,
        currentLanguage,
        sessionId,
        ssoToken,
        query,
      },
    };
  },
);

export default defaultPage(['page-terms-ai'])(TermsAI);
